export const bisque = '#f8e0c3';
export const black = '#000000';
export const brown = '#c16900';
export const cornflower = '#6a68ce';
export const cream = '#f9edd8';
export const crimson = '#9b004e';
export const goldCrayola = '#e3bf99';
export const green = '#659944';
export const lightBlue = '#86d7dc';
export const lightCrimson = '#c6006d';
export const lightGray = '#838d86';
export const lighterGray = '#e3e3e3';
export const lightTaupe = '#bc906d';
export const metallicBronze = '#a17049';
export const orange = '#ffa300';
export const purple = '#501043';
export const purpleBlack = '#280033';
export const rawUmber = '#7d5e48';
export const red = '#fa005a';
export const transparent = '#ffffff00';
export const white = '#ffffff';
export const yellow = '#ffc500';
